import {Injectable} from '@angular/core';

/**
 * Projects their own people may open but not change, because the account's
 * plan has ended. CanvasAuthGuardService decides; SyncService.canEdit reads.
 *
 * A lapsed owner kept full editing on any project shared view-only, public
 * or Open Guest. Turning them away instead left them unable even to look at
 * a project anyone with its link can see, so they get it read-only.
 */
@Injectable({providedIn: 'root'})
export class PlanAccessState {
  private readonly lapsed = new Set<string>();

  setLapsed(projectId: string, lapsed: boolean) {
    if (!projectId) {
      return;
    }
    if (lapsed) {
      this.lapsed.add(projectId);
    } else {
      this.lapsed.delete(projectId);
    }
  }

  isLapsed(projectId: string): boolean {
    return !!projectId && this.lapsed.has(projectId);
  }
}
